// @owners { team: patients-team }
import { VERIFICATION_COMMS_CHANNEL, type VerificationCommsChannel } from '~shared/actions/verifications';
import InjectionVideo from '~shared/assets/images/InjectionVideo.png';
import PharmacistCheckmark from '~shared/assets/images/PharmacistCheckmark.png';
import fertilityPackage from '~shared/assets/images/fertilityPackage.png';
import pharmacistOnboarding from '~shared/assets/images/pharmacistOnboarding.png';
export const VERIFICATION_TITLE = 'Verify account';
export const RESEND_VERIFICATION_TITLE = 'Resend code';

export const VERIFICATION_SINGLE_OPTION_BODY = (channel: VerificationCommsChannel, contact: string): string => {
  switch (channel) {
    case VERIFICATION_COMMS_CHANNEL.email:
      return `For your security, we’ll send a verification code by email to ${contact}.`;

    case VERIFICATION_COMMS_CHANNEL.sms:
      return `For your security, we’ll send a verification code by text/SMS to the phone number ending in ${contact}.`;

    case VERIFICATION_COMMS_CHANNEL.call:
      return `For your security, we’ll send a verification code by automated voice call to the phone number ending in ${contact}.`;

    default:
      return '';
  }
};

export const VERIFICATION_MULTIPLE_OPTIONS_BODY =
  'For your security, we’ll send a verification code to confirm your account. Please select a verification method:';

export const VERIFICATION_OPTIONS_TEXT = (channel: VerificationCommsChannel, contact: string): string => {
  switch (channel) {
    case VERIFICATION_COMMS_CHANNEL.email:
      return `Email to ${contact}`;

    case VERIFICATION_COMMS_CHANNEL.sms:
      return `Text/SMS to the phone number ending in ${contact}`;

    case VERIFICATION_COMMS_CHANNEL.call:
      return `Automated voice call to the phone number ending in ${contact}`;

    default:
      return '';
  }
};

export const VERIFICATION_CTA_TEXT = 'Send code';
export const VERIFICATION_CTA_LOADING_TEXT = 'Sending code...';

export const VERIFICATION_SENT_BODY = (
  channel: VerificationCommsChannel | null | undefined,
  contact: string,
): string => {
  switch (channel) {
    case VERIFICATION_COMMS_CHANNEL.email:
      return `For your security, we’ve sent a verification code to ${contact}. Please enter the 6 digit code below.`;

    case VERIFICATION_COMMS_CHANNEL.sms:
      return `For your security, we’ve sent a verification code by text/SMS to the phone number ending in ${contact}. Please enter the 6 digit code below.`;

    case VERIFICATION_COMMS_CHANNEL.call:
      return `For your security, we’ve sent a verification code by automated voice call to the phone number ending in ${contact}. Please enter the 6 digit code below.`;

    default:
      return '';
  }
};

export type Service = {
  id: number;
  icon: string;
  title: string;
  description: string;
};

export const services: Service[] = [
  {
    id: 1,
    icon: pharmacistOnboarding,
    title: 'Medication delivery to your door',
    description: 'Convenient home delivery',
  },
  {
    id: 2,
    icon: fertilityPackage,
    title: 'Unpacking & storage guidance',
    description: 'Clear storage instructions',
  },
  {
    id: 3,
    icon: InjectionVideo,
    title: 'Step-by-step injection videos',
    description: 'Visual guidance for injections',
  },
  {
    id: 4,
    icon: PharmacistCheckmark,
    title: 'Expert help when you need it',
    description: 'Professional support available',
  },
];
